import Vue from 'vue';
import noty from './noty.service';

export default {
    async getClientGamesLists(clientId) {
        return (await Vue.http.get(`/api/gameslists/byclient/${clientId}`)).data;
    },
    async updateGamesList(list) {
        let l = await Vue.http.post('/api/gameslists/update', list);
        noty.success(`games list ${list.name} updated for client ${list.clientId}`);
        return l;
    },
    async createGamesList(list) {
        let l = await Vue.http.post('/api/gameslists/create', list);
        noty.success(`games list ${list.name} created for client ${list.clientId}`);
        return l;
    }
};



// WEBPACK FOOTER //
// ./src/services/gamesList.service.js